module.exports = __webpack_public_path__ + "src/img/xuanti.f5b88063.svg";